import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars';
import { semanticColors } from '../Globals/styles';
import * as actions from './actions';

const propTypes = {}

const defaultProps = {}

const styles = {
    searchField: {
        boxShadow: 'none',
        borderRadius: 0,
        height: 36,
        border: '1px solid #ccc',
    },
    container: {
        height: '100%',
        width: '100%',
        paddingTop: 10,
        backgroundColor: semanticColors.default,
    },
    searchContainer: {
        width: '75%',
    },
    saveButton: {
        width: 100
    },
    top: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingRight: 10,
    },
    pricelistsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        paddingTop: 10,
    },
    pricelistRow: {
        display: 'flex',
        cursor: 'pointer',
    },
}

class PricelistsList extends Component {
    componentWillMount() {
        const { dispatch } = this.props
        dispatch(actions.getCustomPricelists())
    }

    splitSearch = () => {
        const { search } = this.props
        let filtered = []
        search.split(' ').forEach((w) => {
            if (w.length > 0) {
                filtered.push(w)
            }
        })
        return filtered
    }

    renderCustomPricelist = (c) => {
        const { selectedJohn, onSelect, dispatch } = this.props
        const che = selectedJohn === c.customPricelistId ?
            <i
                className="fa fa-check-square-o"
                style={{ padding: 5 }}
                aria-hidden="true"
            ></i>
            :
            <i
                className="fa fa-square-o"
                style={{ padding: 5 }}
                aria-hidden="true"
            ></i>
        return (
            <div
                key={c.customPricelistId}
                style={styles.pricelistRow}
                onClick={() => {
                    if (onSelect) {
                        onSelect(c.customPricelistId)
                    }
                    dispatch(actions.setSelectedPricelist(c.customPricelistId)
                    )
                }}
            >
                {che}
                <div style={{ wordBreak: 'break-all', padding: 2 }}>
                    {c.name}
                </div>
            </div>
        )
    }

    renderCustomPricelists = () => {
        const { customPricelists, search } = this.props
        if (search) {
            let cps = customPricelists
            if (search.length > 1) {
                let searchWords = this.splitSearch();
                cps = customPricelists.filter((c) => {
                    let passed = []
                    for (var i = 0; i < searchWords.length; i++) {
                        if (c.name.toLowerCase().indexOf(searchWords[i].toLowerCase()) > -1) {
                            passed.push(true)
                        }
                    }
                    return passed.length === searchWords.length
                })
            }
            return cps.map((c) => {
                return this.renderCustomPricelist(c)
            })
        }
        return customPricelists.map((c) => {
            return this.renderCustomPricelist(c)
        })
    }


    render() {
        const { customPricelists, search, dispatch } = this.props
        return (
            <div style={styles.container}>
                <div style={styles.top}>
                    <div style={styles.searchContainer}>
                        <div className="input-group">
                            <span className="input-group-addon" style={{ backgroundColor: 'white' }}>
                                <i className="fa fa-search" aria-hidden="true">
                                </i>
                            </span>
                            <input
                                type="text"
                                style={styles.searchField}
                                placeholder="Søg"
                                value={search}
                                onChange={(e) => dispatch(actions.setSearchTerm(e.target.value))}
                            />
                        </div>
                    </div>
                    <button
                        onClick={() => window.open(window.location.origin + '/prislister', '_blank')}
                        className={"btn btn-primary waves-btn"}
                    >
                        Vis alle
                        </button>
                </div>
                <div
                    style={styles.pricelistsContainer}
                >
                    <Scrollbars style={{ height: '100%', width: '100%' }}
                        renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                        renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                    >
                        {search ? null : this.renderCustomPricelist({ customPricelistId: 'default', name: 'Standardprisliste' })}
                        {this.props.loadingCustomPricelists ?
                            <div style={{ position: 'absolute', left: '50%', top: '50%' }}>
                                <i className="fa fa-spinner fa-spin fa-3x" />
                            </div>
                            : this.renderCustomPricelists()}
                    </Scrollbars>
                </div>
            </div>
        )
    }
}

PricelistsList.propTypes = propTypes

PricelistsList.defaultProps = defaultProps


const selectProps = state => {
    return {
        ...state.pricelistsListReducer,
    };
}

export default connect(selectProps)(PricelistsList)


// WEBPACK FOOTER //
// ./src/App/PricelistsList/index.js